import { NgSelectModule } from '@ng-select/ng-select';

export const ExternalModuleImports = [
  NgSelectModule,
];
